import { JsonObject, JsonProperty } from 'typescript-json-serializer';

@JsonObject()
class PresetPage {
    constructor(
        @JsonProperty({ required: true }) readonly id: string,
        @JsonProperty({ required: true }) readonly userId: string,
        @JsonProperty({ required: true }) readonly deploymentId: string,
        @JsonProperty({ required: true }) readonly presetKey: string
    ) {}
}

export default PresetPage;
